/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown> }} Notifications_Document_Classified_TitleInputs */

const en_notifications_document_classified_title = /** @type {(inputs: Notifications_Document_Classified_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Document classified on case ${i?.caseNumber}`)
};

const pt_br2_notifications_document_classified_title = /** @type {(inputs: Notifications_Document_Classified_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Documento classificado no caso ${i?.caseNumber}`)
};

/**
* | output |
* | --- |
* | "Document classified on case {caseNumber}" |
*
* @param {Notifications_Document_Classified_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_document_classified_title = /** @type {((inputs: Notifications_Document_Classified_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Document_Classified_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_document_classified_title(inputs)
	return pt_br2_notifications_document_classified_title(inputs)
});